import dayjs from "dayjs";
import { storage } from "./storage";

export const ESTACIO_INIT_DATE = "2022-07-11T00:00:00.000";
export const ESTACIO_END_DATE = "2022-07-15T23:59:00.000";

export function getUserEnemScore(): number | null {
	if (storage.getItem("userEnemScore")) {
		return JSON.parse(storage.getItem("userEnemScore")!).userEnemScore;
	}
	return null;
}

export function isEstacioWeek(): boolean {
	const endDate = dayjs(ESTACIO_END_DATE);
	const today = dayjs();
	return today.isAfter(ESTACIO_INIT_DATE) && today.isBefore(endDate);
}
